import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import MatchmakingPlatform from "../pages/matchmaking/page";
import EndToEndService from "../pages/end-to-end/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/matchmaking-platform",
    element: <MatchmakingPlatform />,
  },
  {
    path: "/end-to-end-service",
    element: <EndToEndService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;